<template>
    <div class="tw-flex tw-flex-col lg:tw-flex-row tw-pt-3 lg:tw-pt-6 tw-pb-12 tw-border-0 md:tw-border-t md:tw-border-b md:tw-border-dark-grey">

        <div class="tw-flex tw-flex-col tw-w-full lg:tw-w-1/6 tw-border-b tw-border-dark-grey lg:tw-border-0 tw-mb-4 lg:tw-mb-0">
            <div class="h7 pb-2">Crew Alert</div>
            <div v-show="is_preview"
                 class="tw-flex tw-flex-col lg:tw-flex-row tw-gap-3 tw-pt-3 lg:tw-pt-6 tw-pb-12 tw-border-0 md:tw-border-t md:tw-border-b md:tw-border-dark-grey">
                <v-btn @click="goToList" class="main-btn">Cancel</v-btn>
                <v-btn @click="submitForm" class="main-btn">Send Alert</v-btn>
            </div>
        </div>
        <div class="tw-flex tw-flex-col tw-w-full tw-pt-3 lg:tw-pt-0 tw-pb-12">
            <div class="tw-flex tw-flex-col tw-border-b tw-border-dark-grey md:tw-border-0">
                <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-2 tw-w-full tw-mb-10 lg:tw-mb-6" v-show="!is_preview">
                    <v-btn @click="$inertia.visit(route('crewalerts.index'))" class="main-btn">Return to Crew Alert List</v-btn>
                    <v-btn @click="$inertia.visit(route('crewalerts.show.new'))" class="main-btn">New Crew Alert</v-btn>
                </div>
                <div class="tw-text-4xl tw-uppercase tw-pb-3 sm:tw-pb-1">Crew Alert Detail <span v-show="is_preview"> Preview</span></div>
                <div class="tw-flex tw-w-full tw-font-light tw-pb-5 tw-text-red-500" v-show="is_preview">
                    This is a preview, please review it and click the send alert button when you are ready.
                </div>
                <div>
                    <crew-alert-info-item
                        v-for="(summary_info_item, summary_info_item_index) of summary_info"
                        :key="summary_info_item_index"
                        :text="summary_info_item_index"
                        :value="summary_info_item"
                        :valuelists="valuelists"
                        :constants="constants"
                    />
                    <div class="tw-flex tw-flex-col tw-w-full lg:tw-w-1/6 tw-border-b tw-border-dark-grey lg:tw-border-0 tw-mb-10 lg:tw-mb-0">
                        <h4 class="tw-mt-7">Users {{is_preview || crew_alert.is_delivered ? users_count : ' Will Appear Below Once Delivery Is Complete'}}</h4>
                    </div>
                    <smart-table
                        v-if="is_preview || crew_alert.is_delivered"
                        :items="users"
                        :headers="headers"
                        flat
                        disable-pagination
                        hide-default-footer
                        class="tw-w-full"
                    >
                        <template v-slot:item.first_name="{ isMobile, item, header, value, index}">
                            <div>{{ item.first_name }} {{ item.last_name }}</div>
                        </template>
                        <template v-slot:item.functions.name="{ isMobile, item, header, value, index}">
                            <div>{{ displayCategories(item) }}</div>
                        </template>
                    </smart-table>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import AppLayoutSidebarNav from "@/Layouts/AppLayoutSidebarNav.vue";
    import CrewAlertsFilters from "@/Pages/ExternalPages/CrewAlertsFilters.vue";
    import DatePicker from "@/Generic/DatePicker.vue";
    import CrewAlertInfoItem from "@/Pages/ExternalPages/CrewAlertInfoItem.vue";

    export default {
        name: "CrewAlertsShow",
        layout: (h, page) => {
            return h(AppLayoutSidebarNav, [
                page
            ])
        },
        components: {
            CrewAlertInfoItem,
            DatePicker,
            CrewAlertsFilters,
            SmartTable,
        },
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'crew_alert': {
                type: Object,
                required: true,
            },
            'users': {
                type: Array,
                required: false,
                default: function () {
                    return []
                }
            },
            'is_preview': {
                type: Boolean,
                required: false,
                default: function () {
                    return false
                }
            },
            'preview_request': {
                type: FormData,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                inputs_valid: null,
                record: {},
                new_file_to_upload: null,
                errors: {},
            }
        },
        computed: {
            call_sheet_status() {
                return !!this.new_file_to_upload ? this.constants?.CALL_SHEET_STATUSES?.CALL_SHEET_STATUS_ATTACHED : this.constants?.CALL_SHEET_STATUSES?.CALL_SHEET_STATUS_TO_FOLLOW
            },
            summary_info() {
                return {
                    "Date & Time Issued":       `${this.crew_alert?.date_issued} @ ${this.crew_alert?.time_issued}`,
                    "Date Required":            this.crew_alert?.date_required_temp,
                    "Job Category":             this.crew_alert?.title_function?.name,
                    "Location":                 this.crew_alert?.location,
                    "Skill":                    this.crew_alert?.skill?.name,
                    "Unit":                     this.crew_alert?.unit,
                    "Call Time":                this.crew_alert?.call_time,
                    "Call Sheet":               this.crew_alert?.call_sheet,
                    "Crew Contact":             this.crew_alert?.crew_contact,
                    "Contract":                 this.crew_alert?.contract,
                    "Production Title":         (this.crew_alert?.production?.alternate_name) ? `${this.crew_alert?.production?.name} - ${this.crew_alert?.production?.alternate_name}` : this.crew_alert?.production?.name,
                    "Company Name":             this.crew_alert?.company_name,
                    "Address":                  this.crew_alert?.address,
                    "Phone":                    this.crew_alert?.phone,
                    "Email":                    this.crew_alert?.email,
                    "Notes":                    this.crew_alert?.notes,
                    "Sent By":                  `${this.crew_alert?.issuer?.first_name} ${this.crew_alert?.issuer?.last_name}`,
                }
            },
            headers() {
                return [
                    {value: 'first_name',               text: 'Name',               align: `start`,     sortable: true,    filterable: false },
                    {value: 'email',                    text: 'Email',              align: `start`,     sortable: true,    filterable: false },
                    {value: 'functions.name',           text: 'Job Category',       align: `start`,     sortable: true,    filterable: false },
                    {value: 'availability_info',        text: 'Availability',       align: `start`,     sortable: true,    filterable: false },
                ]
            },
            users_count() {
                if (!this.users?.length) return null
                return `(${this.users.length})`
            }
        },
        methods: {
            async submitForm () {
                axios.post(route('crewalerts.store'), this.preview_request)
                    .then((response) => {
                        let new_id = response?.data?.crew_alert?.id
                        this.$root.snackbar.success("Your Crew Alert Has Been Received. You will receive an email once it has been processed.")
                        setTimeout(()=>{
                            this.$inertia.visit(route(`crewalerts.show`, new_id).url())
                        }, 1000)
                    })
                    .catch((error) => {
                        if( error?.response ) {
                            this.$root.snackbar.error(error.response.data.message)
                            this.errors = error.response?.data?.errors
                        } else {
                            console.log(error)
                            this.$root.snackbar.error(error)
                        }
                    })
            },
            goToList() {
                this.$inertia.visit(route(`crewalerts.index`).url())
            },
            handleArrayForInfoItem(data_array, prop_name) {
                if (!data_array || !Array.isArray(data_array) || (Array.isArray(data_array) && data_array.length === 0)) return null
                return data_array.map(element => element[prop_name]).filter(element=>element)
            },
            displayDateRequired() {
                let from = this.crew_alert.date_required_from
                let to = this.crew_alert.date_required_to && (this.crew_alert.date_required_to !== this.crew_alert.date_required_from) ? ` - ${this.crew_alert.date_required_to}` : null
                return `${from}${to}`
            },
            displayCategories(item) {
                if (!item?.functions?.length) return ''
                let refined = item.functions.map((title) => title.function_name)
                return refined.join(', ')
            },
        },

        watch: {
            record(newValue, oldValue) {
                this.resetValidation()
            },
            new_file_to_upload(newValue, oldValue) {
                this.resetValidation()
            },
        },
    }
</script>

